<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->



/* ============================================================
   NOIR LUXURY REDESIGN — Scroll Animations
   ============================================================ */
(function() {
  'use strict';
  
  // Wait for DOM
  document.addEventListener('DOMContentLoaded', function() {
    
    // Add animation classes to sections
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function(section, index) {
      // Add base animation class
      section.classList.add('noir-animate');
      
      // Alternate animation types for variety
      var animations = ['noir-fade-up', 'noir-fade-up', 'noir-scale', 'noir-fade-up'];
      section.classList.add(animations[index % animations.length]);
      
      // Add stagger to grids inside sections
      var grids = section.querySelectorAll('.grid, .collection-list__wrapper, .halo-row, .slick-list');
      grids.forEach(function(grid) {
        grid.classList.add('noir-stagger');
      });
    });
    
    // Product cards get individual animations
    var cards = document.querySelectorAll('.product-card, .card, .collection-card');
    cards.forEach(function(card) {
      card.classList.add('noir-animate', 'noir-fade-up');
    });
    
    // Intersection Observer for scroll-triggered animations
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('noir-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.08,
        rootMargin: '0px 0px -40px 0px'
      });
      
      // Observe all animated elements
      document.querySelectorAll('.noir-animate').forEach(function(el) {
        observer.observe(el);
      });
      
    } else {
      // Fallback: just show everything
      document.querySelectorAll('.noir-animate').forEach(function(el) {
        el.classList.add('noir-visible');
      });
    }
    
    // Parallax-lite on hero image (subtle)
    var heroSection = document.querySelector('.shopify-section:first-child');
    if (heroSection) {
      var heroImg = heroSection.querySelector('img');
      if (heroImg) {
        window.addEventListener('scroll', function() {
          var scrolled = window.pageYOffset;
          if (scrolled < 800) {
            heroImg.style.transform = 'translateY(' + (scrolled * 0.15) + 'px) scale(1.05)';
          }
        }, { passive: true });
      }
    }
    
  });
})();
